// Design-driven UI that has no supporting backend yet (see
// docs/SecurityReview-2026-07-17.md-adjacent design integration notes).
// Every flag here defaults to false: the corresponding UI must stay absent
// from the rendered widget — not just visually hidden with CSS, but never
// inserted into the DOM — until a real data/logic source exists and a flag
// is flipped. This is the single place that decides whether any of these
// render at all, so turning one on later never requires touching the
// components themselves.
export interface WidgetFeatureFlags {
  replyPreview: boolean;
  emojiPicker: boolean;
}

export const WIDGET_FEATURE_FLAGS: WidgetFeatureFlags = {
  replyPreview: false,
  emojiPicker: false,
};
